<template>
  <el-dialog
    title="電子地圖"
    :visible.sync="dialogVisible"
    width="60%"
    :before-close="handleClose"
  >
    <span>{{ address }}</span>
    <el-row :gutter="20">
      <el-col :span="16">
        <el-input
          placeholder="請輸入內容"
          v-model="MapAddress"
          clearable
          style="padding-bottom: 10px"
        ></el-input>
      </el-col>
      <el-col :span="2">
        <el-button type="primary" plain @click="replaceLocationFromMap">
          取代
        </el-button>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="8">經緯度: {{ mapLatitude }},{{ mapLongitude }}</el-col>
    </el-row>
    <google-map
      name="example"
      ref="mapMarker"
      :input-latitude="latitude"
      :input-longitude="longitude"
      :size="mapSize"
      style="height: 600px"
      @deliveryGPSData="listenGPSFromMap"
    ></google-map>
  </el-dialog>
</template>
<script>
import GoogleMap from '../../pages/mapComponent/LandmarkMap.vue'

export default {
  props: ['address', 'latitude', 'longitude'],
  components: {
    GoogleMap,
  },
  data() {
    return {
      mapLatitude: 0,
      mapLongitude: 0,
      dialogVisible: false,
      mapSize: 12,
      MapAddress: '',
    }
  },
  methods: {
    setMarkerOnMap(val) {
      setTimeout(() => {
        this.$refs.mapMarker.setLatLng(val.latitude, val.longitude)
      }, 1000)
    },
    openDialog(val) {
      this.dialogVisible = !this.dialogVisible
      if (val.latitude !== null || val.longitude !== null) {
        this.mapLatitude = val.latitude
        this.mapLongitude = val.longitude
        this.MapAddress = val.address
        this.setMarkerOnMap(val)
      }
    },
    listenGPSFromMap(val) {
      console.log(val)
      this.mapLatitude = val.geometry.location.lat()
      this.mapLongitude = val.geometry.location.lng()
      let address = val.formatted_address
        .trim()
        .replace(/\s/, '')
        .replace(/^\d+/, '')
      if (address.slice(0, 2) === '台灣') {
        this.MapAddress = address.slice(2, address.length)
      }
    },
    replaceLocationFromMap() {
      let payload = {
        latitude: this.mapLatitude,
        longitude: this.mapLongitude,
        address: this.MapAddress,
      }
      this.$emit('mapGps', payload)
      this.dialogVisible = false
    },
    handleClose(done) {
      done()
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/element_ui/MapDialog.vue